// extracted by mini-css-extract-plugin
export default {"hpSummaryContent":"styles_hpSummaryContent__Im4dO","label":"styles_label__Jrq2J","button":"styles_button__e1Ctk"};